import {
  Input
} from "./chunk-KEJVP5JP.mjs";
import {
  cn
} from "./chunk-DYSUVPH5.mjs";
import {
  __objRest,
  __spreadValues
} from "./chunk-SGYJX2RX.mjs";

// src/components/combobox/combobox.tsx
import { useCombobox } from "downshift";
import React from "react";
var Combobox = (_a) => {
  var _b = _a, {
    options,
    value,
    onChange,
    onInputChange,
    onInputClear,
    startOpen = false,
    maxDropdownHeight = 900
  } = _b, inputProps = __objRest(_b, [
    "options",
    "value",
    "onChange",
    "onInputChange",
    "onInputClear",
    "startOpen",
    "maxDropdownHeight"
  ]);
  const {
    isOpen,
    getComboboxProps,
    getInputProps,
    getMenuProps,
    highlightedIndex,
    getItemProps,
    selectItem
  } = useCombobox({
    items: options,
    itemToString: (item) => (item == null ? void 0 : item.label) || "",
    initialSelectedItem: value,
    onInputValueChange: onInputChange,
    onSelectedItemChange: onChange,
    initialIsOpen: startOpen
  });
  return /* @__PURE__ */ React.createElement("div", { className: "relative w-full" }, /* @__PURE__ */ React.createElement("div", __spreadValues({}, getComboboxProps()), /* @__PURE__ */ React.createElement(
    Input,
    __spreadValues(__spreadValues({
      onClear: () => {
        selectItem({});
        onInputClear == null ? void 0 : onInputClear();
      }
    }, getInputProps()), inputProps)
  )), /* @__PURE__ */ React.createElement("div", { className: "absolute z-10 w-full" }, /* @__PURE__ */ React.createElement(
    "ul",
    __spreadValues({
      className: cn(
        "relative m-0 mt-1 w-full min-w-[300px] list-none space-y-1 overflow-auto rounded border bg-interactive-subtle-surface px-0 shadow-lg focus:outline-none",
        {
          "hidden opacity-0": !isOpen,
          "visible opacity-100": isOpen
        }
      ),
      style: { maxHeight: maxDropdownHeight }
    }, getMenuProps()),
    isOpen && options.map((item, index) => /* @__PURE__ */ React.createElement(
      "li",
      __spreadValues({
        key: `${item.id}${index}`,
        className: cn(
          "cursor-pointer bg-interactive-subtle-surface px-4 py-2 text-foreground transition-all duration-200 ease-in-out my-body-sm hover:bg-interactive-subtle-surface-hover",
          {
            "bg-interactive-subtle-surface-hover": highlightedIndex === index
          }
        )
      }, getItemProps({ item, index })),
      item.label
    )),
    isOpen && options.length === 0 && /* @__PURE__ */ React.createElement("li", { className: "cursor-not-allowed px-4 py-3 text-center my-body-sm" }, /* @__PURE__ */ React.createElement("div", { "aria-label": "Loading", className: "text-foreground-subtle" }, "No results"))
  )));
};

export {
  Combobox
};
